<script lang="ts" setup>
import { useDolyame } from '~/composables/dolyame'
import formatter from '~/helpers/formatter'

const props = defineProps<{
  price: number
}>()

const { installments } = useDolyame(toRef(() => props.price))
</script>

<template>
  <div class="flex justify-between space-x-2 rounded-xl border border-solid border-[#e9e9e9] px-5 py-2">
    <div v-for="(x, i) in installments" :key="i" class="flex-1">
      <div class="mb-0.5 text-xs leading-[140%] text-main-aluminum">
        {{ x.date }}
      </div>
      <div class="mb-2 text-sm font-medium">
        {{ formatter.formatPrice(x.amount) }}&nbsp;₽
      </div>
      <div class="h-1 rounded-full" :class="i === 0 ? 'bg-main-green' : 'bg-[#e9e9e9]'" />
    </div>
  </div>
</template>
